import React from "react";
import { connect } from "react-redux";
import { getForgeToken } from "../../helpers/axios/Get";
import PropertyExtension from "./PropertyExtension";
import AwaToolBarExtension from "./AwaToolBarExtension";
import NestedViewer from "./NestedViewer";
import MarkupExtension from "./MarkupExtension";
import MarkupToolbarExtension from "./MarkupToolBarExtension";
import { statDynaProperties } from "../meta-properties/static_dynamic_properties";
import IsolateLayer from "./IsolateLayer";
import store from "../../helpers/store/Store";
import {
  properties,
  showObjProperties,
  updateMetaProp,
  updateSelectedTag,
  updateDynaPropValues,
  updateStatPropValues,
  updateShowAll,
  updateShowSelection,
  updateAdditionalTabs,
  setMarkupExtension,
  setViewerAppState,
  updatePdfState,
  updatePdf,
} from "../../helpers/actions/Action";
import { ISSUE_URL, VIEWER_API } from "../../helpers/constants/Constants";

import axios from "axios";
import { HOST_URL } from "../../helpers/constants/Constants";
import { debounce } from "debounce";
/* global Autodesk, THREE */ // eslint-disable-line

var metaPropData = [];
var dynaPropValueData = [];
var statPropValueData = [];
var uniqueCategories = [];
var dbIdCount = 0;
var isMetaPropDataLoaded = false;

var pdf = null;
var pageNumber = 0;

class PdfData {
  constructor(document) {
    this.doc = document;
    this.pages = [];
    // this.url = function() {
    //   return Autodesk.Viewing.endpoint.getItemApi() + this.doc.myPath;
    // }
  }

  parse() {
    const filter = {
      type: "geometry",
      role: "2d",
    };

    const doc = this.doc;
    const rootItem = doc.getRoot();
    console.log("rootItem ", rootItem);
    const viewables = rootItem.search(filter);
    console.log("viewables ", viewables);

    if (viewables.length === 0) {
      console.error("Document contains no viewables.");
      return false;
    }

    const pages = viewables.map((v) => {
      const files = v.search({ role: "pdf-page" });
      const file = files[0];

      if (!file) return;
      const urn = file.data.urn;

      return {
        guid: v.guid(),
        raw: v,
        name: v.name(),
        urn,
        url: function () {
          return Autodesk.Viewing.endpoint.getItemApi() + urn;
        },
      };
    });

    this.pages = pages;

    if (!pages || pages.length <= 0) return false;

    return true;
  }
}

let viewer;
const options = {
  env: "AutodeskProduction",
  accessToken: "YourAccessToken",
};

const documentId =
  "urn:dXJuOmFkc2sub2JqZWN0czpvcy5vYmplY3Q6bXlidWNrZXQvRTE1MDEyX1RVRl9aMzkwTS1QUk9fR0FNSU5HX1dpLUZpX1VNX1YyX1dFQi5wZGY";
Autodesk.Viewing.Initializer(options, function () {
  Autodesk.Viewing.Document.load(
    documentId,
    onDocumentLoadSuccess,
    onDocumentLoadFailure
  );
});

function onDocumentLoadSuccess(doc) {
  buildPdfPageList(doc);

  const container = document.getElementById("viewer");
  viewer = new Autodesk.Viewing.GuiViewer3D(container);
  viewer.start();

  viewer.loadExtension("Autodesk.PDF").then(() => {
    const event = new Event("click");
    const page = document.querySelector("#pdf-pages-wrapper a");
    page.dispatchEvent(event);
  });
}

function onDocumentLoadFailure(viewerErrorCode) {
  console.error("onDocumentLoadFailure() - errorCode:" + viewerErrorCode);
}

function onLoadModelSuccess(model) {
  console.log("onLoadModelSuccess()!");
  console.log("Validate model loaded: " + (viewer.model === model));
  console.log(model);
}

function onLoadModelError(viewerErrorCode) {
  console.error("onLoadModelError() - errorCode:" + viewerErrorCode);
}

function buildPdfPageList(doc) {
  const pdf = new PdfData(doc);
  pdf.parse();
  const pageWrapperContainer = document.getElementById("pdf-pages-wrapper");
  const pagesContainer = document.createElement("ul");
  pageWrapperContainer.appendChild(pagesContainer);

  for (let i = 0; i < pdf.pages.length; i++) {
    const page = pdf.pages[i];
    console.log(page);
    const pageHolder = document.createElement("li");
    pagesContainer.appendChild(pageHolder);

    const pageItem = document.createElement("a");
    pageHolder.appendChild(pageItem);

    pageItem.href = "#";
    pageItem.innerText = page.name;
    pageItem.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      document
        .querySelectorAll("#pdf-pages-wrapper a")
        .forEach((e) => e.classList.remove("active"));
      e.target.classList.add("active");

      viewer.tearDown();
      const url = page.url();

      console.log(page, url);
      viewer.loadModel(url, { page: 1 }, onLoadModelSuccess, onLoadModelError);
    });
  }
}

let _viewerId;
class Viewer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      null: false,
      viewerApp: null,
      _viewer: null,
      selectedProject: null,
      id: null,
      viewState: null,
      hidePushPinsAtStart: true,
    };

    this.saveAndClearMetaProps();
  }

  saveAndClearMetaProps = () => {
    metaPropData = [];
    dynaPropValueData = [];
    statPropValueData = [];
    uniqueCategories = [];
    dbIdCount = 0;
    isMetaPropDataLoaded = false;

    store.dispatch(updateDynaPropValues([]));
    store.dispatch(updateStatPropValues([]));
    store.dispatch(updateMetaProp([[], [], false]));
    store.dispatch(updateSelectedTag(""));
  };

  reloadViewer = (urn, id, view, model) => {
    this.launchViewer(urn, id, null, model);
  };

  launchViewer = (urn, id, view, model) => {
    _viewerId = id;
    let self = this;

    let options = {
      env: "AutodeskProduction",
      api: VIEWER_API,
      getAccessToken: getForgeToken,
      refreshToken: getForgeToken,
      PushPinExtensionHandle: null,
    };

    let config3d = {
      extensions: [
        "PropertyExtension",
        "AwaToolBarExtension",
        "IsolateLayer",
        "Autodesk.Viewing.MarkupsCore",
        // "Autodesk.Viewing.MarkupsGui",
        "Autodesk.PDF",
        "Autodesk.DocumentBrowser",
      ],
      id: id,
      selectedProject: this.props.selectedModel,
    };
    // console.log("selectedProject =", this.props.selectedModel);
    // console.log("id =", id);
    console.log("Urn = ", urn);
    console.log("id = ", id);
    console.log("model = ", model);

    let documentId = urn;
    Autodesk.Viewing.Initializer(options, function onInitialized() {
      let viewerId = document.getElementById(id + "-viewer");
      ////OriginalCode
      console.log("ViewerId = ", id + "-viewer");
      self.state.viewerApp = new Autodesk.Viewing.GuiViewer3D(
        viewerId,
        config3d
      );
      Autodesk.Viewing.Document.load(
        documentId,
        self.onDocumentLoadSuccess,
        self.onDocumentLoadFailure
      );

      //Her Working Example
      //   Autodesk.Viewing.Initializer(options, async function () {
      //   const viewer = new Autodesk.Viewing.GuiViewer3D(document.getElementById(id + "-viewer"));
      //   viewer.start();
      //   viewer.setTheme('light-theme');
      //   viewer.loadExtension('Autodesk.PDF').then(() => {
      // //       viewer.loadModel("https://docs.b360.eu.autodesk.com/projects/f9d2aa5f-5d59-4211-a0c1-2e759509ce41/folders/urn:adsk.wipemea:fs.folder:co.-EGLIjWeR6ue-0noef7Sow/detail/viewer/items/urn:adsk.wipemea:dm.lineage:FP1e3ezaSjS7XArb-NRUSg?format=.pdf");
      //       viewer.loadModel("https://developer.api.autodesk.com/derivativeservice/v2/regions/eu/derivatives/urn:adsk.viewing:derived.rpfile.cddc:dXJuOmFkc2sud2lwZW1lYTpmcy5maWxlOnZmLkZQMWUzZXphU2pTN1hBcmItTlJVU2c_dmVyc2lvbj0x/output/1/page.pdf");
      //   });
      //  });
    });
  };

  onDocumentLoadSuccess = (doc) => {
    //---------------------Pdf
    // var docUrl = Autodesk.Viewing.endpoint.getItemApi() + doc.myPath;
    // console.log( docUrl);
    // var testUrl =
    //   Autodesk.Viewing.endpoint.getItemApi() +
    //   "urn:adsk.viewing:fs.file:dXJuOmFkc2sud2lwZW1lYTpmcy5maWxlOnZmLm8zbDRNaVNOVEVTWnc3Z2FlRTNxSGc_dmVyc2lvbj0x";
    // console.log("TestUrl =", testUrl);

    if (this.props.selectedModel.fileType == "pdf") {
      // store.dispatch(updatePdfState("true"));
      pdf = new PdfData(doc);
      pdf.parse();
      let options = {
        env: "AutodeskProduction",
        api: VIEWER_API,
        getAccessToken: getForgeToken,
        refreshToken: getForgeToken,
        PushPinExtensionHandle: null,
      };
      const page = pdf.pages[pageNumber];
      const url = page.url();
      console.log(page, url);
      console.log("pdf:", pdf);
      // store.dispatch(updatePdf(pdf));

      Autodesk.Viewing.Initializer(options, async function () {
        const viewer = new Autodesk.Viewing.GuiViewer3D(
          document.getElementById(_viewerId + "-viewer")
        );
        viewer.start();
        viewer.setTheme("light-theme");
        viewer.loadExtension("Autodesk.PDF").then(() => {
          viewer.loadModel(url);
          viewer.loadExtension("Autodesk.DocumentBrowser");
        });
      });
    }
    //---------------------Pdf

    let viewables = (viewables = doc.getRoot().search({ type: "geometry" }));
    if (!viewables.length) {
      console.error("Document contains no viewables.");
      return;
    }
    // console.log("doc =", doc);

    let initialViewable = viewables[0];
    this.setState({ viewable: initialViewable });
    let svfUrl = doc.getViewablePath(initialViewable);
    // console.log("svfUrl =", svfUrl);
    let modelOptions = {
      sharedPropertyDbPath: doc.getFullPath(doc.getRoot().findPropertyDbPath()),
      isAEC: true,
    };
    // console.log("viewables =", viewables);
    // console.log("initialViewable =", initialViewable);
    this.state.viewerApp.start(
      svfUrl,
      modelOptions,
      this.onLoadModelSuccess,
      this.onLoadModelError
    );
    // console.log("modelOptions =", modelOptions);

    store.dispatch(setViewerAppState(this.state.viewerApp));

    var viewerCreated = this.state.viewerApp;
    viewerCreated.addEventListener(
      Autodesk.Viewing.OBJECT_TREE_CREATED_EVENT,
      this.onObjectTreeCreated
    );
  };

  loadNextPage = ()=>{
    this.loadPdf(1);
  }

  loadPreviousPage = ()=>{
    this.loadPdf(-1);
  }

  loadPdf = (pageIncriment) => {
    debugger;
    if ((pageNumber+pageIncriment>0)&&(pageNumber+pageIncriment<pdf.pages.length)){
      pageNumber = pageNumber + pageIncriment
    }

    const page = pdf.pages[pageNumber];
    const url = page.url();

    let options = {
      env: "AutodeskProduction",
      api: VIEWER_API,
      getAccessToken: getForgeToken,
      refreshToken: getForgeToken,
      PushPinExtensionHandle: null,
    };

    Autodesk.Viewing.Initializer(options, async function () {
      const viewer = new Autodesk.Viewing.GuiViewer3D(document.getElementById(_viewerId+"-viewer"));
      viewer.start();
      viewer.setTheme('light-theme');
      viewer.loadExtension('Autodesk.DocumentBrowser')
      viewer.loadExtension('Autodesk.PDF').then(() => {
          viewer.loadModel(url);
      });
     });
  };

  onObjectTreeCreated = () => {
    var viewerCreated = this.state.viewerApp;
    var instanceTree = viewerCreated.model.getData().instanceTree;
    var allDbIdsStr = Object.keys(instanceTree.nodeAccess.dbIdToIndex);
    // console.log("viewerCreated =", viewerCreated);
    // console.log("viewerCreated2 =", this.state.viewerApp);
    // console.log("viewerCreated.model =", viewerCreated.model);
    var allDbIdsInt = allDbIdsStr.map(function (id) {
      return parseInt(id);
    });

    // viewerCreated.model.getBulkProperties(allDbIdsInt, null, (elements)=>{
    //    console.log(elements);
    // })

    dbIdCount = allDbIdsInt.length;
    allDbIdsInt.forEach((dbId) => {
      viewerCreated.model.getProperties(
        dbId,
        this.onSuccessGetProperties,
        this.onErrorGetProperties
      );
    });
  };

  onSuccessGetProperties = (data) => {
    // console.log("Data in on success =", data);
    var guId = "";
    var dbId = "";
    var tag = "";
    var category = "";
    var propertyValues = [];
    var statProps = [];
    var dynaProps = [];
    var locked = false;

    --dbIdCount;

    for (var i = 0; i < data.properties.length; i++) {
      if (data.properties[i].displayName === "GUID") {
        guId = data.properties[i].displayValue;
      }
      if (data.properties[i].displayName === "P&ID Class") {
        category = data.properties[i].displayValue;
      }
      if (data.properties[i].displayName === "Tag") {
        dbId = data.dbId;
        propertyValues = data.properties;
        tag = data.properties[i].displayValue;
      }
    }

    if (tag !== "") {
      if (category === "") {
        category = "Error - Object needs a P&ID Class";
      }
      for (var j = 0; j < statDynaProperties.length; j++) {
        if (statDynaProperties[j].type === category) {
          dynaProps = statDynaProperties[j].dynamic;
          statProps = statDynaProperties[j].static;
          // carbonProps = statDynaProperties[j].carbon;
        }
      }
      metaPropData.push({
        guId: guId,
        dbId: dbId,
        tag: tag,
        category: category,
        propertyValues: propertyValues,
        statProps: statProps,
        dynaProps: dynaProps,
        locked: locked,
      });

      uniqueCategories.indexOf(category) === -1
        ? uniqueCategories.push(category)
        : console.log();
    }

    // var filteredData = data.properties.filter((item) => {
    //   return item.displayName === "P&ID Class";
    // });

    // if (filteredData.length !== 0) {
    //   if (!(filteredData[0].displayValue in categoryDbidData))
    //     //New
    //     categoryDbidData[filteredData[0].displayValue] = [data.dbId];
    //   //Already existing
    //   else categoryDbidData[filteredData[0].displayValue].push(data.dbId);
    // }

    if (dbIdCount === 0) {
      metaPropData.map((elem, index) => {
        this.createStateVariables(
          elem.tag,
          elem.category,
          elem.dynaProps,
          elem.statProps,
          elem.propertyValues,
          elem.locked,
          elem.guId
        );
      });

      // this.syncStaticData(statPropValueData, this.syncCarbonData);

      this.syncDynaPropValueWithServer(() => {
        this.performDispatches();
        // this.saveData();
        this.saveTabData();
      });
    }
  };
  // {
  //   var guId = "";
  //   var dbId = "";
  //   var tag = "";
  //   var category = "";
  //   var propertyValues = [];
  //   var statProps = [];
  //   var dynaProps = [];

  //   --dbIdCount;

  //   for (var i = 0; i < data.properties.length; i++) {
  //     if (data.properties[i].displayName === "GUID") {
  //       guId = data.properties[i].displayValue;
  //     }
  //     if (data.properties[i].displayName === "P&ID Class") {
  //       category = data.properties[i].displayValue;
  //     }
  //     if (data.properties[i].displayName === "Tag") {
  //       dbId = data.dbId;
  //       propertyValues = data.properties;
  //       tag = data.properties[i].displayValue;
  //       //category= data.properties[i].displayCategory.replace("DWF - ","")

  //       for (var j = 0; j < statDynaProperties.length; j++) {
  //         if (statDynaProperties[j].type === category) {
  //           dynaProps = statDynaProperties[j].dynamic;
  //           statProps = statDynaProperties[j].static;
  //         }
  //       }

  //       metaPropData.push({
  //         guId: guId,
  //         dbId: dbId,
  //         tag: tag,
  //         category: category,
  //         propertyValues: propertyValues,
  //         statProps: statProps,
  //         dynaProps: dynaProps,
  //       });

  //       uniqueCategories.indexOf(category) === -1
  //         ? uniqueCategories.push(category)
  //         : console.log();
  //       //console.log(metaPropData)
  //       //console.log(uniqueCategories)
  //       break;
  //     }
  //   }

  //   if (dbIdCount === 0) {
  //     metaPropData.map((elem, index) => {
  //       this.createStateVariables(
  //         elem.tag,
  //         elem.category,
  //         elem.dynaProps,
  //         elem.statProps,
  //         elem.propertyValues
  //       );
  //     });

  //     this.syncDynaPropValueWithServer(() => {
  //       this.performDispatches();
  //       this.saveTabData();
  //     });
  //   }
  // };

  onErrorGetProperties = (dbId) => {
    --dbIdCount;

    if (dbIdCount === 0) {
      metaPropData.map((elem, index) => {
        this.createStateVariables(elem.tag, elem.dynaProps);
      });

      this.syncDynaPropValueWithServer(() => {
        this.performDispatches();
        this.saveTabData();
      });
    }
    console.log("Failed to fetch properties");
  };

  performDispatches() {
    store.dispatch(updateDynaPropValues(dynaPropValueData));
    store.dispatch(updateStatPropValues(statPropValueData));
    isMetaPropDataLoaded = true;
    store.dispatch(
      updateMetaProp([metaPropData, uniqueCategories, isMetaPropDataLoaded])
    );
  }

  saveData() {
    debugger;
    var formDataStatic = new FormData();
    formDataStatic.append("Data", JSON.stringify(statPropValueData));
    axios({
      method: "post",
      url: HOST_URL + `/api/savestatic`,
      data: formDataStatic,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then(() => {})
      .catch((error) => {
        console.log(error);
      });

    var formDataDynamic = new FormData();
    formDataDynamic.append("Data", JSON.stringify(dynaPropValueData));
    var savedStatic = false,
      savedDynamic = false;

    axios({
      method: "post",
      url: HOST_URL + `/api/savedynamic`,
      data: formDataDynamic,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then(() => {
      })
      .catch((error) => {
        console.log(error);
        alert("An Error Occured: " + error);
      });
  }

  saveTabData = () => {
    // store.dispatch(updateAdditionalTabs(true));
    // console.log("MetaPropData in saveTabData =", metaPropData);
    // console.log("uniqueCategories in saveTabData =", uniqueCategories);
    // console.log("dynaPropValueData in saveTabData =", dynaPropValueData);
    // console.log("statPropValueData in saveTabData =", statPropValueData);
    var tabData = {
      ElemWithProps: JSON.stringify(metaPropData),
      Categories: JSON.stringify(uniqueCategories),
      DynaPropValues: JSON.stringify(dynaPropValueData),
      StatPropValues: JSON.stringify(statPropValueData),
    };
    const tabSize =
      tabData.ElemWithProps.length +
      tabData.Categories.length +
      tabData.DynaPropValues.length +
      tabData.StatPropValues.length;

    // console.log("tabSize", tabSize);
    if (tabSize > 4700000) {
      store.dispatch(updateAdditionalTabs(false));
    } else {
      //redux state to change tab possible to true
      store.dispatch(updateAdditionalTabs(true));
      window.sessionStorage.setItem(
        this.props.selectedModel.fileName,
        JSON.stringify(tabData)
      );
    }
  };

  syncDynaPropValueWithServer = (callback) => {
    var formData = new FormData();
    formData.append(
      "Data",
      JSON.stringify({
        projectName: this.props.data.text,
        fileName: this.props.selectedModel.fileName,
      })
    );

    axios({
      method: "post",
      url: HOST_URL + `/api/getdynamic`,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((response) => {
        for (let i = 0; i < dynaPropValueData.length; i++) {
          var responseDynaPropvalue = response.data.filter((obj) => {
            var match =
              obj.Tag == dynaPropValueData[i].tag &&
              (obj.ProjectName == dynaPropValueData[i].projectName ||
                obj.Locked);
            return match;
          });
          // dynaPropValueData[i].propValueList =responseDynaPropvalue[0].PropertyValueData;
          var metaprop = metaPropData.find(
            (o) => o.tag == dynaPropValueData[i].tag
          );
          if (metaprop) {
            metaprop.locked = responseDynaPropvalue[0].Locked;
          }
          for (let j = 0; j < dynaPropValueData[i].propValueList.length; j++) {
            var filteredData =
              responseDynaPropvalue[0].PropertyValueData.filter((item) => {
                return (
                  item.propName ===
                  dynaPropValueData[i].propValueList[j].propName
                );
              });
            //console.log(filteredData)
            if (filteredData.length !== 0)
              dynaPropValueData[i].propValueList[j].propValue =
                filteredData[0].propValue;
          }
        }
        callback();
        // this.setState(
        //   {
        //     dynaPropValues: dynaPropValueData,
        //   },
        //   callback
        // );
      })
      .catch((error) => {
        callback();
        console.log(error);
      });
  };

  createStateVariables = (
    tag,
    category,
    dynaProps,
    statProps,
    propValueList,
    locked,
    guId
  ) => {
    dynaPropValueData.push({
      projectName: this.props.data.text,
      fileName: this.props.selectedModel.fileName,
      tag: tag,
      guId: guId,
      category: category,
      propValueList: dynaProps.map((dynaProp) => {
        return {
          propName: dynaProp,
          propValue: "",
        };
      }),
      locked: locked,
    });

    let propValueListTemp = [];
    for (let i = 0; i < statProps.length; i++) {
      for (let j = 0; j < propValueList.length; j++) {
        if (statProps[i] == "GUID") {
        }
        if (propValueList[j].displayName == statProps[i]) {
          propValueListTemp.push({
            propName: statProps[i],
            propValue: propValueList[j].displayValue,
          });
        }
      }
    }
    statPropValueData.push({
      projectName: this.props.data.text,
      fileName: this.props.selectedModel.fileName,
      tag: tag,
      guId: guId,

      category: category,
      propValueList: propValueListTemp,
    });
    this.state.viewerApp.setGroundShadow(false);
  };

  onDocumentLoadFailure = (viewerErrorCode) => {
    console.error("onDocumentLoadFailure() - errorCode:" + viewerErrorCode);
  };

  onLoadModelSuccess = (viewer, item) => {
    let self = this;
    this.setState({ _viewer: viewer });

    this.state.viewerApp
      .getToolbar()
      .getControl("settingsTools")
      .removeControl("toolbar-propertiesTool");
    this.state.viewerApp
      .getToolbar()
      .getControl("settingsTools")
      .removeControl("toolbar-fullscreenTool");
    this.state.viewerApp.addEventListener(
      Autodesk.Viewing.SELECTION_CHANGED_EVENT,
      this.onSelect
    );
    this.state.viewerApp.setReverseZoomDirection(true);

    this.state.viewerApp.setTheme("light-theme");

    let extensionOptions = {
      hideIssuesButton: true,
      hideRfisButton: true,
      hideFieldIssuesButton: false,
      visibility: false,
    };

    this.state.viewerApp
      .loadExtension("Autodesk.Viewing.MarkupsCore")
      .then(function (markupsExt) {
        store.dispatch(setMarkupExtension(markupsExt));
      });

    this.state.viewerApp
      .loadExtension("Autodesk.BIM360.Extension.PushPin", extensionOptions)
      .then(function (extension) {
        self.setState({
          PushPinExtensionHandle: extension,
        });
        const axios = require("axios");
        //console.log(ISSUE_URL);
        axios
          .get(ISSUE_URL + self.props.selected.projectid, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.data.length !== 0) {
              self.registerOnSelectEvent(response.data, viewer);
              self.renderIssues(response.data);
            }
          })
          .catch((error) => {
            console.log("Error, cannot get issues from API", error);
          });
      });

    //We need to add the nested viewer only after the document is loaded as the nested viewer will subscribe to the onClick event of the NestedViewerButton.
    //Nested viewer button loads only after the document is loaded.
    this.state.viewerApp.loadExtension("NestedViewer", {
      filter: ["2d", "3d"],
      crossSelection: true,
    });

    this.state.viewerApp.loadExtension("MarkupExtension");

    // this.state.viewerApp.loadExtension("MarkupToolbarExtension");
    this.state.viewerApp.loadExtension("Autodesk.DocumentBrowser");
    this.state.viewerApp.loadExtension("Autodesk.PDF");
  };

  onSelect = (event) => {
    console.log("SELECTED***************************************", event);
    this.setState({ viewState: this.state.viewerApp.viewerState.getState() });
    //  store.dispatch(updateSelectedTag(""));
    if (
      this.state.viewState != null &&
      this.state.viewState.objectSet.length != 0
    ) {
      this.state.viewerApp.model.getProperties(
        this.state.viewState.objectSet[0].id[0],
        this.onSuccessGetSelectedTag,
        () => console.log("Failed to get tag number.")
      );
    }
  };

  onSuccessGetSelectedTag = (data) => {
    console.log("******DATA = ******", data);
    var tag = "";
    for (var i = 0; i < data.properties.length; i++) {
      if (data.properties[i].displayName === "Tag") {
        tag = data.properties[i].displayValue;

        // store.dispatch(updateSelectedTag(tag));

        break;
      }
    }

    if (tag === "" && data.dbId !== undefined) {
      // let newInstanceTree = this.viewer.model.getData().instanceTree;
      var viewerCreated = this.state.viewerApp;
      var instanceTree = viewerCreated.model.getData().instanceTree;
      let parentId = instanceTree.getNodeParentId(data.dbId);
      viewerCreated.getProperties(parentId, this.onSuccessGetSelectedTag, () =>
        console.log("Failed to get tag number.")
      );
    }
    store.dispatch(updateSelectedTag(tag));
    store.dispatch(updateShowAll(false));
    store.dispatch(updateShowSelection(true));
  };

  registerOnSelectEvent = (issues, viewer) => {
    let self = this;
    this.state.PushPinExtensionHandle.pushPinManager.addEventListener(
      "pushpin.selected",
      (e) => {
        if (e.value) {
          let project = self.state.viewerApp.config.selectedProject;
          e.value.label.hide();
          let data = [
            {
              category:
                "Issues" + project.hrefbim360 + "/issues/" + e.value.data.id,
              data: {
                id: e.value.data.id,
                status: e.value.data.status_label,
                displayName: e.value.data.title,
                displayValue: project.hrefbim360 + "/issues/" + e.value.data.id,
              },
            },
          ];
          store.dispatch(
            properties({ id: this.props.id, data: data, issue: true })
          );
          store.dispatch(showObjProperties({ id: this.props.id, show: true }));
        }
        self.state.viewerApp.restoreState(this.state.viewState);
      }
    );
  };

  renderIssues = (issues) => {
    let self = this;
    let pins = [];

    issues.forEach(function (issue) {
      let issueAttributes = issue.attributes;
      let pushpinAttributes = issue.attributes.pushpin_attributes;

      if (
        pushpinAttributes &&
        issueAttributes.sheet_metadata &&
        issueAttributes.sheet_metadata.sheetGuid ===
          self.state.viewable.data.guid
      ) {
        pins.push({
          id: issue.id,
          status_label: issueAttributes.status,
          title: issueAttributes.title,
          status:
            issue.type && issueAttributes.status.indexOf(issue.type) === -1
              ? `${issue.type}-${issueAttributes.status}`
              : issueAttributes.status,
          position: pushpinAttributes.location,
          type: issue.type,
          objectId: pushpinAttributes.object_id,
          viewerState: pushpinAttributes.viewer_state,
        });
      }
    });
    self.state.PushPinExtensionHandle.loadItemsV2(pins);
    self.state.PushPinExtensionHandle.hideAll();
  };

  onItemLoadFail = (errorCode) => {
    console.error("onItemLoadFail() - errorCode:" + errorCode);
  };

  componentDidMount() {
    this.reloadViewer(this.props.urn, this.props.id, null, this.props.model);
    // console.log("this.props.id =", this.props.id);
  }

  render() {
    let viewerId = this.props.id + "-viewer";
    let { _viewer, PushPinExtensionHandle, hidePushPinsAtStart } = this.state;

    if (this.props.id === this.props.show.id && !this.props.show.show) {
      if (_viewer !== null && PushPinExtensionHandle !== null) {
        this.state._viewer.selector.clearSelection();
      }
    }

    if (_viewer && PushPinExtensionHandle && hidePushPinsAtStart) {
      PushPinExtensionHandle.uiButtons[0].pushPinButton.setState(1);
      this.setState({ hidePushPinsAtStart: false });
    }

    if (
      document.getElementById("toolbar-pushpinFieldIssuesVis") &&
      document.getElementById("toolbar-pushpinFieldIssuesVis-tooltip")
    ) {
      // Sets custom tooltip for the button that hides and shows issues
      document.getElementById(
        "toolbar-pushpinFieldIssuesVis-tooltip"
      ).innerHTML = "Show/Hide issues";

      // Gives each button an unique id so issue visiblity toggling works with multiple viewers open
      document
        .getElementById("toolbar-pushpinFieldIssuesVis")
        .setAttribute("id", "pushpin-toggle-" + this.props.selectedModel.id);
      document
        .getElementById("toolbar-pushpinFieldIssuesVis-tooltip")
        .setAttribute(
          "id",
          "pushpin-toggle-tooltip-" + this.props.selectedModel.id
        );

      // Make sure custom tooltip sticks while toggling visibility
      document
        .getElementById("pushpin-toggle-" + this.props.selectedModel.id)
        .addEventListener("click", () => {
          document.getElementById(
            "pushpin-toggle-tooltip-" + this.props.selectedModel.id
          ).innerHTML = "Show/Hide issues";
        });
    }

    return (
      <>
      {/* <div class="text-center" style={{background:"#bfbfbf"}}><button onClick={this.loadPreviousPage}>&#60;</button><input id="pageInput" type="number"></input><button onClick={this.loadNextPage}>&#62;</button></div> */}
        <div id={viewerId}></div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  data: state.getSelectedProjectReducer.data,
  selectedModel: state.getSelectedModelReducer.data,
  selected: state.getSelectedProjectReducer.data,
  issues: state.requestIssuesDataReducer.data,
  show: state.getStateObjPropertiesReducer.data,
  // markups: state.markupModalReducer.markupModal,
});

export default connect(mapStateToProps)(Viewer);
